import { IRule } from '@/types/newSetup.type';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface IInitialState {
  allRules: IRule[];
  selectedRules: IRule | undefined;
}

// Define the initial state using that type
const initialState: IInitialState = {
  allRules: [],
  selectedRules: undefined,
};

export const rulesSlice = createSlice({
  name: 'rules',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    saveAllRules: (state, action: PayloadAction<IRule[]>) => {
      state.allRules = action.payload;
    },
    saveSelectedRules: (state, action: PayloadAction<{ id: number }>) => {
      state.selectedRules = state.allRules.find((rule) => rule.id === action.payload.id);
    },
  },
});

// Other code such as selectors can use the imported `RootState` type

export const rulesSelector = createSelector(
  (state: RootState) => state.rules,
  (state) => state,
);

export default rulesSlice;
